<template>
  <div>
    <div class="card-header">
      <div class="d-flex justify-content-between w-100">
        <h4>Vulnerabilities</h4>
        <button
          class="btn btn btn-primary "
          type="button"
          v-on:click="openAddVulnerabilityModal"
          v-if="!readonly"
        >
          Add A Vulnerability
        </button>
      </div>
    </div>
    <div class="card-body">
      <p>If the client has any vulnerabilities please log them here.</p>

      <table
        class="table carpenter table-bordered table-hover"
        v-if="hasVulnerabilities"
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-bind:key="index"
            v-for="(vulnerability, index) in vulnerabilities"
            v-on:click="openEditVulnerabilityModal(vulnerability)"
          >
            <td>
              {{
                vulnerability.vulnerability_code
                  ? vulnerability.vulnerability_code.label
                  : 'Not Provided'
              }}
            </td>
            <td>
              {{
                vulnerability.vulnerability_code
                  ? vulnerability.vulnerability_code.category
                  : 'Not Provided'
              }}
            </td>
            <td>
              {{ vulnerability.created_at | dateFormat('DD/MM/YYYY HH:mm') }}
            </td>
          </tr>
        </tbody>
      </table>

      <v-add-vulnerability
        :incident="incident"
        v-if="modals.add"
        v-on:close="closeAddVulnerabilityModal"
        :vulnerabilityConsentMethods="vulnerabilityConsentMethods"
        :vulnerabilityCodes="vulnerabilityCodes"
        :client="client"
        :positions="positions"
        v-on:added="vulnerabilityWasAdded"
      ></v-add-vulnerability>

      <v-edit-vulnerability
        :incident="incident"
        v-if="modals.edit"
        v-on:close="closeEditVulnerabilityModal"
        :vulnerabilityCodes="vulnerabilityCodes"
        :vulnerabilityConsentMethods="vulnerabilityConsentMethods"
        :vulnerability="editingVulnerability"
        :positions="positions"
        :client="client"
        :readonly="readonly"
        v-on:deleted="removeVulnerability"
        v-on:updated="vulnerabilityWasUpdated"
      ></v-edit-vulnerability>
    </div>
  </div>
</template>
<script>
import AddVulnerability from './Children/AddVulnerability.vue';
import EditVulnerability from './Children/EditVulnerability.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'v-add-vulnerability': AddVulnerability,
    'v-edit-vulnerability': EditVulnerability
  },

  data() {
    return {
      modals: {
        add: false,
        edit: false
      },
      types: [],
      positions: [],
      editingVulnerability: null,
      indicator: false
    };
  },

  computed: {
    vulnerabilities() {
      return this.$store.getters['Incident/vulnerabilities'];
    },

    hasVulnerabilities() {
      return !!this.vulnerabilities?.length;
    },

    client() {
      return this.$store.getters['Incident/client'];
    },

    vulnerabilityCodes() {
      return this.$store.getters['VulnerabilityCodes/all'];
    },

    vulnerabilityConsentMethods() {
      return this.$store.getters['VulnerabilityConsentMethods/all'];
    }
  },

  mounted() {
    this.$store.commit('VulnerabilityCodes/retrieve');
    this.$store.commit('VulnerabilityConsentMethods/retrieve');
  },

  filters: {
    dateFormat(value) {
      if (value) {
        return window.DateManager.format(value);
      }

      return null;
    }
  },

  methods: {
    parseDateOfBirth(Vulnerability) {
      if (Vulnerability.date_of_birth) {
        return window.DateManager.format(Vulnerability.date_of_birth);
      }

      return 'Not Provided';
    },

    findIndex(identifier) {
      return this.vulnerabilities.findIndex(item => {
        return item.identifier === identifier;
      });
    },

    removeVulnerability(vulnerability) {
      this.closeEditVulnerabilityModal();

      this.$store.commit(
        'Incident/removeVulnerability',
        vulnerability.identifier
      );

      window.toastify.success(
        'Vulnerability Deleted',
        'The vulnerability was deleted successfully!'
      );
    },

    vulnerabilityWasUpdated(vulnerability) {
      this.closeEditVulnerabilityModal();

      this.$store.commit('Incident/updateVulnerability', vulnerability);

      window.toastify.success(
        'Success!',
        'The vulnerability was updated successfully!'
      );
    },

    closeEditVulnerabilityModal() {
      this.modals.edit = false;
      this.editingVulnerability = null;
    },

    openEditVulnerabilityModal(vulnerability) {
      this.editingVulnerability = vulnerability;
      this.modals.edit = true;
    },

    vulnerabilityWasAdded(vulnerability) {
      this.$store.commit('Incident/addVulnerability', vulnerability);

      this.closeAddVulnerabilityModal();
      this.$emit('updated', true);
      window.toastify.success(
        'Success!',
        'The vulnerability was added successfully!'
      );
    },

    openAddVulnerabilityModal() {
      this.modals.add = true;
    },

    closeAddVulnerabilityModal() {
      this.modals.add = false;
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
